/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReleaseFlag extends models.FeatureFlagBase {
    constructor() {
        super();
        this.setDiscriminator("ReleaseFlag");
    }

    getFixupPrototypeFunction() { return ReleaseFlag.fixupPrototype; }

    static newInstance(model: Partial<ReleaseFlag>): ReleaseFlag {
        let obj = Object.assign(new ReleaseFlag(), model);
        ReleaseFlag.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReleaseFlag>): ReleaseFlag {
        if (!model) return null;
        return ReleaseFlag.newInstance(<ReleaseFlag> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReleaseFlag) {
        if (!obj) return;

        models.ReleaseFlag.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReleaseFlag): boolean {
        if (models.FeatureFlagBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReleaseFlag.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * The release flag's prefix value
     */
    release_prefix: models.ReleasePrefix;

    /**
     * Release id to be controlled
     */
    release_id: string;

}
